import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, BookOpenIcon } from 'lucide-react';
export function Hero() {
  return <section className="min-h-screen bg-gradient-to-br from-primary-dark via-primary to-primary pt-24 pb-16 flex items-center" data-id="element-61">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12 w-full" data-id="element-62">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-10 md:gap-12 items-center" data-id="element-63">
          {/* Photo */}
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="flex justify-center md:justify-start md:col-span-2" data-id="element-64">
            <div className="relative" data-id="element-65">
              <div className="absolute -inset-2 rounded-2xl bg-white/10 backdrop-blur-sm" data-id="element-66"></div>
              <img src="https://cdn.magicpatterns.com/uploads/bc3i4s1d4TQ2NE8g6SDLfU/IMG_0515.jpg" alt="Joe Casciari" className="relative w-[280px] md:w-[320px] lg:w-[380px] h-auto rounded-xl object-cover shadow-2xl" data-id="element-67" />
            </div>
          </motion.div>

          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="md:col-span-3" data-id="element-68">
            <span className="font-sans text-sm tracking-[0.25em] uppercase text-gold font-semibold mb-6 block" data-id="element-69">
              Senior Risk & Treasury Executive
            </span>

            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.1] mb-8" data-id="element-70">
              Risk & Treasury Leader Driving Enterprise-Wide Financial Strategy
            </h1>

            <p className="font-sans text-base md:text-lg text-blue-100/80 leading-relaxed mb-10 max-w-xl font-light" data-id="element-71">
              25+ years leading enterprise risk management, treasury
              optimization, and capital markets strategy across global financial
              institutions — building robust frameworks, leading global teams,
              and driving strategic alignment between risk governance and
              financial performance.
            </p>

            <div className="flex flex-wrap gap-4" data-id="element-72">
              <a href="#experience" className="inline-flex items-center gap-2 font-sans text-sm font-medium text-white border-2 border-white/40 px-6 py-3 hover:bg-white hover:text-primary transition-all duration-300" data-id="element-73">
                View Experience
              </a>
              <a href="#contact" className="inline-flex items-center gap-2 font-sans text-sm font-medium text-white border-2 border-gold px-6 py-3 hover:bg-gold hover:text-primary-dark transition-all duration-300" data-id="element-74">
                Contact Me
              </a>
              <a href="#about" className="inline-flex items-center gap-2 font-sans text-sm font-medium text-blue-200/70 border-2 border-white/15 px-6 py-3 hover:border-white/40 hover:text-white transition-all duration-300" data-id="element-75">
                <BookOpenIcon size={16} data-id="element-76" />
                View Resume
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}